import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';

/**
 * If all user's cars are owned, ask the user to confirm the ownership by asking if they make loan or lease payments.
 */
export const FinancedCarsStep: Step = {
  id: 'financedcars',
  pathname: '/financedcars',
  canShow: (appData) => {
    return !!(appData.selectedCars && appData.selectedCars.length > 0);
  },
  hasData: () => true,
  hasOwnData: () => true,
  category: () => StepCategory.Cars,
};
